import { useInsertItem } from '@/hooks/editor/useInsertItem'
import { useNavigatePage } from '@/hooks/editor/useNavigatePage'
import { useZoom } from '@/hooks/editor/useZoom'

export const useActions = () => {
  const { zoomIn, zoomOut, fitToView } = useZoom()
  const navigatePage = useNavigatePage()
  const insertItem = useInsertItem()

  return {
    zoomIn,
    zoomOut,
    fitToView,
    previousPage: () => navigatePage('previous'),
    nextPage: () => navigatePage('next'),
    insertShape: () => insertItem('shape'),
    insertText: () => insertItem('text'),
    insertImage: (image) => insertItem('image', image),
    insertDesignAsset: (image) => insertItem('designAsset', image),
    insertLine: () => insertItem('line'),
    insertQRCode: () => insertItem('qrCode'),
  }
}
